module.exports = __webpack_public_path__ + "../resources/img/new_search_icon.87f1cff7.svg";